/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Timecode_OffsetInputs */



/**
* | output |
* | --- |
* | "Apply timecode offset" |
*
* @param {Apply_Timecode_OffsetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_timecode_offset = /** @type {((inputs?: Apply_Timecode_OffsetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Timecode_OffsetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer le décalage de timecode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timecode-Offset anwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applica offset del codice temporale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Применить смещение временного кода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar desplazamiento de código de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("应用时间码偏移")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードオフセットを適用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड ऑफ़सेट लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar deslocamento de código de tempo")
	return /** @type {LocalizedString} */ ("Apply timecode offset")
});